import { render, staticRenderFns } from "./CalendarWraperTest.vue?vue&type=template&id=3be8afe1&scoped=true&"
import script from "./CalendarWraperTest.vue?vue&type=script&lang=js&"
export * from "./CalendarWraperTest.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWraperTest.vue?vue&type=style&index=0&id=3be8afe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8afe1",
  null
  
)

export default component.exports